import axios from 'axios'
import { URL_PREFIX } from '../config'

export const getUser = (id, cancelToken = null) => {
  return axios.get(URL_PREFIX + '/users/' + id + '/', {
    cancelToken: cancelToken?.token
  })
}

export const getAllUserAdmin = (page=1, page_size=100) => {
  const params = {
    page: page,
    page_size: page_size
  }
  return axios.get(URL_PREFIX + '/users/', {
    params
  })
}

export const login = (username, password) => {
  return axios.post('/api-token-auth/', {
    username: username,
    password: password
  })
}

export const signup = (email, password, first_name, last_name, invite_code='') => {
  return axios.post('/user-signup-artist/', {
    username: email,
    email: email,
    password: password,
    first_name: first_name,
    last_name: last_name,
    invite_code: invite_code
  })
}

export const signupGallery = (email, password, invite_code='') => {
  return axios.post('/user-signup-gallery/', {
    username: email,
    email: email,
    password: password,
    invite_code: invite_code
  })
}

export const userDeactivate = (userId) => {
  return axios.put('/user-deactivate/', {
    user_id: userId
  })
}

export const resetPwd = (username) => {
  const bodyFormData = new FormData()
  bodyFormData.append('email', username)
  bodyFormData.append('reset', true)
  return axios.post('/login/', bodyFormData)
}

export const updatePwd = (userId, oldPwd, newPwd) => {
  return axios.put('/user-change-pwd/', {
    user_id: userId,
    old_password: oldPwd,
    new_password: newPwd
  })
}

export const userApplyArtist = (params) => {
  return axios.post('/user-apply-artist/', params)
}

export const userGetRole = () => {
  return axios.post('/user-get-role/')
}

export const userGetGalleryInviteCode = () => {
  return axios.get('/gallery-invite-code/')
}

export const adminDeleteUser = (user_id) => {
  return axios.delete('/users/'+user_id+'/', {
    data: {user_id: user_id}
  })
}